module.exports = __webpack_public_path__ + "videos/webinar-meetings.4576192.mp4";